<template>
  <div class="row gamechoose">
    <div class="col-md-12">
      <div class="card">
        <div class="row header-bar">
          <div class="card-header">
            <h4 class="card-title">เลือกเกม</h4>
          </div>
          <div
            class="
              card-header
              col-xxl-2 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-6 col-xs-6
            "
          >
            <fg-input
              class="game-input-search"
              placeholder="Search game"
              addon-right-icon="now-ui-icons ui-1_zoom-bold"
              @keyup="onSearch"
            >
            </fg-input>
          </div>
        </div>
        <div class="card-body">
          <div class="row" v-if="banners">
            <div
              class="col-12 text-center"
              style="display: block; margin: 0 auto"
            >
              <a-carousel autoplay>
                <img
                  :src="banner.picture"
                  :alt="banner.description"
                  v-for="banner in banners"
                  :key="banner.id"
                />
              </a-carousel>
            </div>
          </div>
          <div class="row" v-if="gameLoaded">
            <div
              v-for="n in games"
              v-bind:key="n.id"
              class="col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"
              style="padding: 15px"
            >
              <router-link
                v-bind:to="/game/ + n.code"
                style="text-decoration: none"
              >
                <a-card hoverable>
                  <template #cover>
                    <img alt="example" v-bind:src="n.picture" />
                  </template>
                  <a-card-meta v-bind:title="n.name">
                    <template #description>
                      {{ n.desc }}
                    </template>
                  </a-card-meta>
                </a-card>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ElSelect, ElOption } from "element-plus";
import * as gameservice from "../../services/game";
import * as packageservice from "../../services/package";
import { message } from "ant-design-vue";
import * as configuration from "../../middleware/configuration";
import * as configservice from "../../services/config";

export default {
  components: {
    [ElOption.name]: ElOption,
    [ElSelect.name]: ElSelect,
  },
  methods: {
    toggleCrl() {
      if (this.control_icn === "design_bullet-list-67") {
        this.control_icn = "ui-1_simple-remove";
      } else {
        this.control_icn = "design_bullet-list-67";
      }
    },
    async getGames() {
      try {
        let res = await gameservice.get("games");
        let data = [];
        let res_pack = await packageservice.getAllPackage();
        if (this.role === "agent") {
          let pack = res_pack.data.filter((x) => x.payment === "wallet");
          res.data.map((x) => {
            if (pack.filter((f) => f.gameId == x.id).length > 0) {
              data.push(x);
            }
          });
        } else if (
          this.role === "customer" ||
          this.role === undefined ||
          this.role === "" ||
          this.uid === ""
        ) {
          let pack = res_pack.data.filter((x) => x.payment !== "wallet");
          res.data.map((x) => {
            if (pack.filter((f) => f.gameId == x.id).length > 0) {
              data.push(x);
            }
          });
        } else {
          data = res.data;
        }
        this.games = data;
        this.allGames = res.data;
        localStorage.setItem("GameList", JSON.stringify(res.data));
        this.gameLoaded = true;
      } catch (error) {
        message.error("ไม่สามารถโหลดเกมได้ กรุณาลองอีกครั้ง");
        console.log(error);
      }
    },
    async getBanner() {
      try {
        let res = await configservice.getBanner();
        this.banners = res.data.filter(x => x.isActived);
      } catch (error) {
        console.log(error);
      }
    },
    async getRegions() {
      try {
        let res = await gameservice.get("regions");
        res.data.map((m) => {
          this.selects.regions.push({ value: m.code, label: m.name });
        });
        this.selects.regionsLoaded = true;
      } catch (error) {
        console.log(error);
      }
    },
    async getLanguages() {
      try {
        let res = await gameservice.get("languages");
        res.data.map((m) => {
          this.selects.languages.push({ value: m.code, label: m.name });
        });
        this.selects.languagesLoaded = true;
      } catch (error) {
        console.log(error);
      }
    },
    async getPlatforms() {
      try {
        let res = await gameservice.get("platforms");
        res.data.map((m) => {
          this.selects.Platforms.push({ value: m.code, label: m.name });
        });
        this.selects.PlatformsLoaded = true;
      } catch (error) {
        console.log(error);
      }
    },
    updateGames() {
      var region = this.selects.region;
      var language = this.selects.language;
      var platfrom = this.selects.platfrom;

      this.games = this.allGames.filter(
        (x) =>
          (x.regions == region || region == "") &&
          (x.languages == language || language == "") &&
          (x.platfroms == platfrom || platfrom == "") &&
          (x.name.indexOf(key.target.value) > -1 || key.target.value == "")
      );
    },
    onSearch(key) {
      if (key.keyCode === 13) {
        var region = this.selects.region;
        var language = this.selects.language;
        var platfrom = this.selects.platfrom;
        this.games = this.allGames.filter(
          (x) =>
            (x.regions == region || region == "") &&
            (x.languages == language || language == "") &&
            (x.platfroms == platfrom || platfrom == "") &&
            (x.name.toLowerCase().indexOf(key.target.value.toLowerCase()) >
              -1 ||
              key.target.value == "")
        );
      }
    },
  },
  data() {
    return {
      selects: {
        region: "",
        regionsLoaded: false,
        regions: [
          {
            value: "",
            label: "All Regions",
          },
        ],
        languagesLoaded: false,
        language: "",
        languages: [
          {
            value: "",
            label: "All Language",
          },
        ],
        PlatformsLoaded: false,
        platfrom: "",
        Platforms: [
          {
            value: "",
            label: "All Platform",
          },
        ],
      },
      gameLoaded: false,
      games: [],
      allGames: [],
      control_icn: "design_bullet-list-67",
      role: "",
      banners: []
    };
  },
  async beforeMount() {
    let uid = await configuration.getUid();
    if (uid === "") {
      localStorage.clear();
    }
    let result = await configuration.getIdTokenResult(true);
    if (result) {
      this.role = result.claims.role;
      if (
        result.claims.firebase.sign_in_provider &&
        result.claims.ispasswordchange === false
      ) {
        this.$router.push({
          name: "User Details",
          params: { id: uid, isConfirmPassword: true },
        });
      } else if (
        result.claims.firebase.sign_in_provider &&
        result.claims.ispinchange === false
      ) {
        this.$router.push({
          name: "User Details",
          params: { id: uid, isConfirmPin: true },
        });
      }
    }

    if (
      localStorage.getItem("AcceptTerm") &&
      !localStorage.getItem("IsConfirm") &&
      uid !== ""
    ) {
      this.$router.push("/payment");
    }
    await this.getRegions();
    await this.getLanguages();
    await this.getPlatforms();
    await this.getGames();
    await this.getBanner()
  },
};
</script>

<style lang="scss">
.gamechoose {
  .ant-card-cover > * {
    height: 228px !important;
    object-fit: cover;
  }
  .ant-card-body {
    height: 70px !important;
  }
}

.header-bar {
  padding: 0px 15px 0px 15px;
  position: relative;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .control {
    margin: 1.5em 1.5em 0 0;
    width: 1em;
    z-index: 1;
    top: 0;
    right: 0;
    color: currentColor;
    text-decoration: none;
    cursor: pointer;
    font-size: 1.5em;
    position: absolute;
  }
}
.ant-card-body {
  padding: 16px !important;
}
.ant-card {
  font-size: 11px !important;
}
.ant-card-meta-title {
  font-size: 14px !important;
}
.ant-card-meta-detail > div:not(:last-child) {
  margin-bottom: 0px !important;
}
.header-filter {
  display: flex;
  margin: 0 -0.5em;
  .show {
    display: flex !important;
  }
}

.select-primary {
  flex: 10em;
  margin: 0 0.5em 0 0.5em;
}

.game-search {
  flex: 20em;
  margin: 0.8em 0.5em 0 0.5em;
  .game-input-search {
    height: 3.4em !important;
  }
}

.visible-game-search-regular {
  display: none !important;
  padding-right: 15px !important;
  flex-wrap: wrap;
}

.visible-game-search-mini {
  display: flex !important;
}

.pd0 {
  padding-top: 0px !important;
}

@media (min-width: 1355px) {
  .visible-game-search-mini {
    display: none !important;
  }
  .visible-game-search-regular {
    display: flex !important;
    flex-wrap: inherit !important;
  }

  .pd0 {
    padding-top: 15px !important;
  }
  .select-primary {
    flex: 13em;
    margin: 0.5em;
  }

  .game-search {
    flex: 30em;
    margin: 1.2em 0.5em 0 0.5em;
    .game-input-search {
      height: 3.4em !important;
    }
  }
}
</style>